var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgOpenEndedIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M47 46.012H3c-1.654 0-3-1.346-3-3.001V25.006a3.004 3.004 0 013-3.001h16.858a1 1 0 010 2.001H3c-.551 0-1 .449-1 1v18.005c0 .551.449 1 1 1h44c.551 0 1-.449 1-1V25.006c0-.551-.449-1-1-1h-4.711a1 1 0 110-2.001H47c1.654 0 3 1.346 3 3.001v18.005a3.004 3.004 0 01-3 3.001zm.132-32.095l-2.815 2.816-.002.002-14.752 14.756a.974.974 0 01-.283.189c-.012.006-.018.018-.03.023l-.01.004-9.846 4.221a1 1 0 01-1.313-1.313l4.219-9.847a.296.296 0 00.005-.013c.005-.011.017-.017.022-.029.049-.103.108-.202.19-.284L37.268 9.687l.004-.003 2.814-2.815 1.408-1.409A4.95 4.95 0 0145.017 4a4.95 4.95 0 013.523 1.46 4.99 4.99 0 010 7.049l-1.408 1.408zm-23.57 12.985l-2.658 6.202 6.201-2.658-3.509-3.51-.034-.034zm1.076-1.752l4.218 4.219 13.339-13.343-4.218-4.219L24.638 25.15zM40.793 8.99l-1.402 1.403 4.218 4.219 1.402-1.403-4.218-4.219zm6.333-2.115c-1.127-1.127-3.092-1.126-4.218 0l-.701.701 4.218 4.219.701-.701a2.987 2.987 0 000-4.219z",
    fill: "url(#".concat(_id, ")"),
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "20.041%",
    x2: "22.6%",
    y2: "76.222%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  })))));
}
export default SvgOpenEndedIcon;